import { actionTypes } from './types';
interface IAction {
  type: string;
  res: any;
  error: any;
}

const initialState = {
  dashboardData: {},
  upcomingEvents: [],
};

export function systemAdminDashboard(state = initialState, action: IAction) {
  switch (action.type) {
    case actionTypes.DASHBOARD_REQUEST:
      return { ...state };
    case actionTypes.DASHBOARD_SUCCESS:
      return {
        ...state,
        dashboardData: action.res,
      };
    case actionTypes.DASHBOARD_SUCCESS_TYPE:
      const data = action.res;
      let detail = state['dashboardData'];
      if (data['type'] === 'totalData') {
        detail = { ...detail, totalData: data['totalData'] };
      } else if (data['type'] === 'learningGoals') {
        detail = { ...detail, learningGoals: data['learningGoals'] };
      } else if (data['type'] === 'learners') {
        detail = { ...detail, learners: data['learners'] };
      } else {
        detail = action.res;
      }
      return {
        ...state,
        dashboardData: detail,
      };
    case actionTypes.DASHBOARD_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case actionTypes.LATEST_USERS_REQUEST:
      return { ...state };
    case actionTypes.LATEST_USERS_SUCCESS:
      return {
        ...state,
        latestUsers: action.res,
      };
    default:
      return state;
  }
}
